import React from "react";
import "./../styles/global.css";
import Navbar from "./../components/Navbar";
import LandingNavbar from "./../components/LandingNavbar";
import TermsPage from "./../components/termsofservice";
import PrivacyPage from "./../components/privacy";
import BlogIndex from "./../components/BlogIndex";
import BlogPost from "./../components/BlogPost";
import IndexPage from "./index";
import AboutPage from "./about";
import CampusAmbassadorPageTwo from "./CampusAmbassadorPageTwo";
import TestFlightDownload from "./TestFlightDownload";
import LaChristmasParty from "./lachristmasparty";


import FaqPage from "./faq";
import ContactPage from "./contact";
import PricingPage from "./pricing";
import DashboardPage from "./dashboard";
import Onboarding from "./onboarding";
import CatalogPage from "./CatalogPage";
import ItemDetailPage from "./ItemDetailPage";
import ProfilePage from "./ProfilePage";
import ProfilePageB from "./ProfilePageB";
import GroupPage from "./GroupPage";

//import GroupPage from "./GroupPage";

import AuthPage from "./auth";
import SettingsPage from "./settings";
import LegalPage from "./legal";
import { Switch, Route, Router } from "./../util/router";
import PurchasePage from "./purchase";
import FirebaseActionPage from "./firebase-action";
import NotFoundPage from "./404";
import Footer from "./../components/Footer";
import "./../util/analytics";
import Chat from "./../components/Chat";
import { AuthProvider } from "./../util/auth";
import { QueryClientProvider } from "./../util/db";
import { useRouter } from "./../util/router"; // 9/16

//import { BrowserRouter as Router } from 'react-router-dom';

// ExternalRedirect Component
const ExternalRedirect = ({ to }) => {
  React.useEffect(() => {
    window.open(to, '_blank');
  }, [to]);

  return null;
};

function App(props) {
  return (
    <QueryClientProvider>
      <AuthProvider>
        <Chat />
        <Router>
          <AppContent /> {/* <-- useRouter() can be used here safely */}
        </Router>
      </AuthProvider>
    </QueryClientProvider>
  );
}

function AppContent() {
  const router = useRouter();                 
  const isLanding = router.pathname === "/";  

  const hideLayoutRoutes = ["/other_profile", "/u/:username", "/"]; // "/"

  const shouldHideLayout = hideLayoutRoutes.some(route =>
    router.pathname.startsWith(route)
  );

  return (
    <>{/*} just hide all
      {!shouldHideLayout &&( //  && isLanding  //  isLanding ? <LandingNavbar /> : <Navbar bgColor="bg-white" />. <Navbar bgColor="bg-transparent"/> 
        isLanding ? <LandingNavbar /> : <Navbar bgColor="bg-transparent"/> 
      )}*/}

      <Switch>
        <Route exact path="/" component={IndexPage} />
        <Route exact path="/auth" component={AuthPage} />
        <Route exact path="/settings" component={SettingsPage} />
        <Route exact path="/legal" component={LegalPage} />
        <Route exact path="/purchase" component={PurchasePage} />
        <Route exact path="/about" component={AboutPage} />
        <Route exact path="/contact" component={ContactPage} />
        <Route exact path="/blog" component={BlogIndex} />
        <Route path="/blog/:slug" component={BlogPost} />
        <Route exact path="/terms" component={TermsPage} />
        <Route exact path="/privacy" component={PrivacyPage} />
        <Route exact path="/campus-ambassadors" component={CampusAmbassadorPageTwo} />
        <Route exact path="/invite" component={TestFlightDownload} />
        <Route exact path="/lachristmas" component={LaChristmasParty} />
        <Route exact path="/firebase-action" component={FirebaseActionPage} />
        <Route path="/other_profile" component={ProfilePageB} /> 
        <Route path="/u/:username" component={ProfilePage} />
        {/*matches: groups/hiking-buddies-Ab3DefGh  and /groups/Ab3DefGh*/}
        <Route path="/groups/:slug" component={GroupPage} />

        {/* Catch-all fallback */}
        <Route path="*" component={IndexPage} />
        <Route component={NotFoundPage} />

      </Switch>

      {!shouldHideLayout && ( //&& isLanding 
        <Footer size="md" bgColor="bg-sky-50" sticky />
      )}
    </>
  );
}



function AppOLD(props) {
  const isLanding = window.location.pathname === "/";

  return (
    <QueryClientProvider>
      <AuthProvider>
        <Chat />
        <Router>
          <>
            {/* Navbar              {isLanding ? <LandingNavbar /> : <Navbar bgColor="bg-white" />}*/}
            {isLanding ? <LandingNavbar /> :  <LandingNavbar />}

            <Switch>
              <Route exact path="/" component={IndexPage} />

              <Route exact path="/about" component={AboutPage} />

              <Route exact path="/faq" component={FaqPage} />

              <Route exact path="/contact" component={ContactPage} />

              <Route exact path="/pricing" component={PricingPage} />

              <Route exact path="/dashboard" component={DashboardPage} />
              {/*<Route exact path="/catalog" render={() => <ExternalRedirect to="http://thebookroad.notion.site" />} />*/}

              <Route exact path="/onboarding" component={Onboarding} />
              <Route exact path="/catalog" component={CatalogPage} />
              <Route path="/item/:id" component={ItemDetailPage} />


              <Route exact path="/auth/:type" component={AuthPage} />

              <Route exact path="/settings/:section" component={SettingsPage} />

              <Route exact path="/legal/:section" component={LegalPage} />

              <Route exact path="/purchase/:plan" component={PurchasePage} />

              <Route
                exact
                path="/firebase-action"
                component={FirebaseActionPage}
              />

              <Route component={NotFoundPage} />
            </Switch>

{/*
            <Footer
              size="md"
              bgColor="bg-white"
              bgImage=""
              bgImageOpacity={1}
              textColor=""
              sticky={true}
            />*/}
             {/* Only show footer if NOT landing page */}
            {!isLanding && (
              <Footer
                size="md"
                bgColor="bg-white"
                bgImage=""
                bgImageOpacity={1}
                textColor=""
                sticky={true}
              />
            )}
          </>
        </Router>
      </AuthProvider>
    </QueryClientProvider>
  );
}

export default App;
